import saintGobain from './saint-gobain.svg';

export default {
  'saint-gobain': saintGobain,
};
